"use client"

import "./bootstrap"
import Navigation from "./navigation"
import Reducer from "./common/Reducer"
import { Provider } from "react-redux"
import { persistStore } from "redux-persist"
import { PersistGate } from "redux-persist/integration/react"
import { createStore } from "redux"
import ReactDOM from "react-dom"
import SnackbarProvider from "react-simple-snackbar"
import { ThemeProvider, createTheme } from "@mui/material/styles"
import CssBaseline from "@mui/material/CssBaseline"
import GoogleTranslate from "./components/TranslateWidge"
import { useEffect } from "react"

const store = createStore(Reducer)
const persistor = persistStore(store)

const darkTheme = createTheme({
  palette: {
    mode: "dark",
  },
})

// Unregister all service workers (optional)
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      registration.unregister()
      console.log("Service Worker unregistered:", registration.scope)
    })
  })
}

function App() {
  useEffect(() => {
    // Initialize OneSignal when component mounts
    const initializeOneSignal = async () => {
      try {
        // Wait for OneSignal to be available
        if (typeof window !== "undefined" && window.OneSignal) {
          // Check if already initialized
          if (window.OneSignal._initialized) {
            console.log("OneSignal already initialized")
            return
          }

          await window.OneSignal.init({
            appId: "ec18d70a-842e-4cdb-af5c-c5e37687fac7",
            allowLocalhostAsSecureOrigin: true,
            serviceWorkerParam: {
              scope: "/",
            },
            serviceWorkerPath: "OneSignalSDKWorker.js",
            notificationClickHandlerMatch: "origin",
            notificationClickHandlerAction: "focus",
            promptOptions: {
              slidedown: {
                enabled: true,
                autoPrompt: false, // Changed to false to control when to show
                timeDelay: 5,
                pageViews: 1,
                actionMessage: "We'd like to show you notifications for the latest updates.",
                acceptButtonText: "ALLOW",
                cancelButtonText: "NO THANKS",
              },
            },
          })

          // Mark as initialized
          window.OneSignal._initialized = true

          // Set up event listeners
          window.OneSignal.Notifications.addEventListener("permissionChange", (permissionChange) => {
            console.log("Notification permission changed:", permissionChange)
          })

          window.OneSignal.Notifications.addEventListener("click", (event) => {
            console.log("Notification clicked:", event)
          })

          console.log("OneSignal initialized successfully")

          // Show prompt after a delay
          setTimeout(() => {
            if (window.OneSignal && window.OneSignal.Notifications) {
              window.OneSignal.Notifications.requestPermission().then((permission) => {
                console.log("Permission status:", permission)
              })
            }
          }, 3000)
        } else {
          console.error("OneSignal SDK not loaded")
        }
      } catch (err) {
        console.error("OneSignal initialization error:", err)
      }
    }

    // Load OneSignal SDK script dynamically
    const loadOneSignal = () => {
      // Check if script already exists
      if (document.querySelector('script[src*="OneSignalSDK"]')) {
        console.log("OneSignal script already loaded")
        initializeOneSignal()
        return
      }

      const script = document.createElement("script")
      script.src = "https://cdn.onesignal.com/sdks/web/v16/OneSignalSDK.page.js"
      script.async = true
      script.defer = true
      script.onload = () => {
        console.log("OneSignal SDK loaded")
        // Wait a bit for SDK to be ready
        setTimeout(initializeOneSignal, 1000)
      }
      script.onerror = (error) => {
        console.error("Failed to load OneSignal SDK:", error)
      }
      document.head.appendChild(script)
    }

    loadOneSignal()

    return () => {
      // Cleanup if needed
    }
  }, [])

  return (
    <Provider store={store}>
      <PersistGate loading={<div loading={"true"} />} persistor={persistor}>
        <ThemeProvider theme={darkTheme}>
          <CssBaseline />
          <SnackbarProvider>
            <Navigation />
            <div
              style={{
                position: "fixed",
                bottom: "10px",
                left: "10px",
                zIndex: 9999,
                backgroundColor: "#121212",
                borderRadius: "4px",
                padding: "4px",
              }}
            >
              <GoogleTranslate />
            </div>
          </SnackbarProvider>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  )
}

if (document.getElementById("root")) {
  ReactDOM.render(<App />, document.getElementById("root"))
}
